<template>
  <div class="feedback-comment flow">
    <div
      class="feedback-comment__header"
      v-if="!$basil.isNil(title)">
      <h3 class="feedback-comment__title">{{ title }}</h3>
    </div>

    <div class="feedback-comment__body">
      <forms-textarea
        :disabled="readonly"
        :required="data.required"
        :placeholder="$t('user-portal.feedback_textarea_placeholder')"
        :errors="errors"
        v-model="currentValue"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackComment',

  props: {
    data: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      default: ''
    },

    errors: {
      type: Array,
      default: []
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentValue: ''
    }
  },

  watch: {
    currentValue(newValue) {
      this.$emit('input', newValue)
    },
  },

  computed: {
    title() {
      return this.$basil.get(this.data, 'title')
    },
  },

  mounted() {
    this.currentValue = this.value
  },
}
</script>
